// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__18JMN","head":"ProcedureTableInfo_head__1K3zK"};